<!-- error text keeps the surrounding colour here: red is too faint on this gradient (see tailwind.css) -->
<div class="flex justify-center items-center w-full [--error-text-color:currentColor]">
  <div class="grow">
    <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" class="h-screen w-screen absolute top-0 left-0">
      <defs>
        <radialGradient id="Gradient1" cx="50%" cy="50%" fx="10%" fy="50%" r=".5">
          <animate attributeName="fx" dur="34s" values="0%;3%;0%" repeatCount="indefinite" />
          <stop offset="0%" stop-color="#ff0" />
          <stop offset="100%" stop-color="#ff00" />
        </radialGradient>
        <radialGradient id="Gradient2" cx="50%" cy="50%" fx="10%" fy="50%" r=".5">
          <animate attributeName="fx" dur="23.5s" values="0%;3%;0%" repeatCount="indefinite" />
          <stop offset="0%" stop-color="#0ff" />
          <stop offset="100%" stop-color="#0ff0" />
        </radialGradient>
        <radialGradient id="Gradient3" cx="50%" cy="50%" fx="50%" fy="50%" r=".5">
          <animate attributeName="fx" dur="21.5s" values="0%;3%;0%" repeatCount="indefinite" />
          <stop offset="0%" stop-color="#f0f" />
          <stop offset="100%" stop-color="#f0f0" />
        </radialGradient>
      </defs>
      <rect x="0" y="0" width="100%" height="100%" fill="url(#Gradient1)">
        <animate attributeName="x" dur="20s" values="25%;0%;25%" repeatCount="indefinite" />
        <animate attributeName="y" dur="21s" values="0%;25%;0%" repeatCount="indefinite" />
        <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="17s" repeatCount="indefinite" />
      </rect>
      <rect x="0" y="0" width="100%" height="100%" fill="url(#Gradient2)">
        <animate attributeName="x" dur="23s" values="-25%;0%;-25%" repeatCount="indefinite" />
        <animate attributeName="y" dur="24s" values="0%;50%;0%" repeatCount="indefinite" />
        <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="18s" repeatCount="indefinite" />
      </rect>
      <rect x="0" y="0" width="100%" height="100%" fill="url(#Gradient3)">
        <animate attributeName="x" dur="25s" values="0%;25%;0%" repeatCount="indefinite" />
        <animate attributeName="y" dur="26s" values="0%;25%;0%" repeatCount="indefinite" />
        <animateTransform attributeName="transform" type="rotate" from="360 50 50" to="0 50 50" dur="19s" repeatCount="indefinite" />
      </rect>
    </svg>
    <h1 class="text-6xl font-bold text-center text-white/25 mix-blend-overlay tracking-tighter [text-shadow:0_0_5px_#fff] mb-16 lg:mb-28">CrowdSync</h1>
    <!-- the width keeps 1rem of the background either side on phones; max-w caps it as before -->
    <div class="flex bg-white/15 ring-1 ring-black/5 rounded-xl backdrop-blur-md shadow-lg overflow-hidden w-[calc(100%-2rem)] mx-auto max-w-sm lg:max-w-4xl">
      <div
        class="hidden lg:block lg:w-1/2 bg-cover bg-center opacity-85"
        [ngStyle]="{'background-image': 'url(assets/images/logo-main.png)'}"
      ></div>
      <div class="w-full p-8 lg:w-1/2">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
